import { Component } from "react";

import { withAuthenticationManager } from "./GeneralServices/AuthenticationService";
import { getDisplayName } from "./Utils/getDisplayName";

function buttonWithAuthorization(WrappedComponent) {
  class ButtonWithAuthorization extends Component {
    static displayName = `ButtonWithAuthorization(${getDisplayName(WrappedComponent)})`;

    constructor() {
      super();

      this.authenticate = this.authenticate.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onAuthenticated = this.onAuthenticated.bind(this);
      this.storeButtonRef = this.storeButtonRef.bind(this);
    }

    get disabled() {
      return this.props.authorization === "UNAUTHORIZED";
    }

    get actionURI() {
      if (!this.props.actionURI) {
        return null;
      } else if (this.props.actionURI.match(/^\//)) {
        let { protocol, host } = window.location;

        return [protocol, host].join("//") + this.props.actionURI;
      } else {
        return this.props.actionURI;
      }
    }

    authenticate(callback = this.onAuthenticated) {
      const { beforeAuthenticate, authenticate } = this.props;

      // Apply potential filter before authentication
      if (beforeAuthenticate && !beforeAuthenticate()) return;

      authenticate(callback);
    }

    onClick() {
      this.authenticate();
    }

    onAuthenticated() {
      if (this.props.onSignIn) {
        this.props.onSignIn();
      } else if (this.props.triggerOnSignIn && this.button) {
        // Force authorization since we're signed-in.
        this.button.onClick({ authorization: "AUTHORIZED" });
      }
    }

    storeButtonRef(button) {
      this.button = button;
    }

    componentDidMount() {
      if (this.actionURI && this.button && this.actionURI === window.location.href) {
        // Handle the case where the page has been reloaded after sign in, and the
        // button's action URI is the current location, meaning we want to run
        // the action now that we are signed in.
        //
        setTimeout(() => this.button.onClick(), 0);
      }
    }

    render() {
      return (
        <>
          <WrappedComponent
            {...this.props}
            buttonRef={this.storeButtonRef}
            disabled={this.disabled}
            onClick={this.onClick}
            authenticate={this.authenticate}
            requiresAuth={this.props.requiresAuth}
          />
        </>
      );
    }
  }

  return withAuthenticationManager(ButtonWithAuthorization);
}

export { buttonWithAuthorization };
